import * as React from 'react';

import { FlexBox } from '../box';
import { styled } from '../styled';
import { ColorProp, getPaletteColor } from '../theme';
import { Typography } from '../typography';

export interface ContextLineProps {
    label: React.ReactNode;
    children?: React.ReactNode;
    color?: ColorProp;
    lineColor?: ColorProp;
}

const StyledFlexBox = styled(FlexBox)<{ $lineColor?: ColorProp }>(
    ({ theme, $lineColor }) => ({
        borderLeft: '4px solid',
        borderColor: getPaletteColor(theme, $lineColor)
    })
);

export const ContextLine = React.forwardRef<HTMLDivElement, ContextLineProps>(
    ({ color, lineColor, label, children }, ref) => {
        return (
            <StyledFlexBox
                ref={ref}
                stack
                gap={0.5}
                padding={[0.25, 0, 0.25, 2]}
                $lineColor={lineColor}
            >
                <Typography color={color}>{label}</Typography>
                {children}
            </StyledFlexBox>
        );
    }
);
